// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-quick-title-container {
  display: flex;
  padding: calc(var(--theia-ui-padding) / 2);
  justify-content: space-between;
  align-items: center;
  background: var(--theia-titleBar-activeBackground);
}

.theia-quick-title-left-bar {
  display: flex;
  text-align: left;
}

.theia-quick-title-right-bar {
  display: flex;
  text-align: right;
}

.theia-quick-title-header {
  text-align: center;
}

.theia-quick-title-button {
  width: var(--theia-icon-size);
  height: var(--theia-icon-size);
  display: flex;
  align-items: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/quick-title-bar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,aAAa;EACb,0CAA0C;EAC1C,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-quick-title-container {\n  display: flex;\n  padding: calc(var(--theia-ui-padding) / 2);\n  justify-content: space-between;\n  align-items: center;\n  background: var(--theia-titleBar-activeBackground);\n}\n\n.theia-quick-title-left-bar {\n  display: flex;\n  text-align: left;\n}\n\n.theia-quick-title-right-bar {\n  display: flex;\n  text-align: right;\n}\n\n.theia-quick-title-header {\n  text-align: center;\n}\n\n.theia-quick-title-button {\n  width: var(--theia-icon-size);\n  height: var(--theia-icon-size);\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
